import initAxios from '../axios'

import * as libAxios from '~/lib/axios'
import libLodash from '~/lib/lodashe'
import libStr from '~/lib/str'

import addons from '../addons'

export default {initAxios, libAxios, libLodash, libStr, addons}
